export default __webpack_public_path__ + "static/media/Logo-SHB-EN.6e0ffa70.png";